import React from 'react'
import PropTypes from 'prop-types'
import translate from '../../../../modules/translate'
import ErrorBoundary from '../../../Error/widgets/ErrorBoundary'
import SkeletonDistrict from './skeleton'
import southTyrolDistricts from '../../../../config/data/southTyrolDistricts'
import loadable from '@loadable/component'

const ListDistrict = loadable(() => import(/* webpackChunkName: "ListDistrict" */ '../../components/ListDistrict'))

const getPathDistrict = ({ districtPath }) => {
  if (!districtPath) return false
  return southTyrolDistricts.all.find((district) => district.value === districtPath.replace('-', '_'))
}

const errorOptions = {
  component: translate('district'),
  link: '/',
  linkText: translate('error_try_homepage'),
  logError: 'District screen display',
}

const ScreenDistrict = ({ loading, error, response, match, ready, ...props }) => {
  const data = response && response.data
  const district = match && match.params.district && getPathDistrict({ districtPath: match.params.district })
  if (loading) ListDistrict.preload()

  return (
    <ErrorBoundary error={error} {...errorOptions} {...props}>
      {loading && <SkeletonDistrict district={district} />}
      {data && <ListDistrict data={data} />}
    </ErrorBoundary>
  )
}

ScreenDistrict.propTypes = {
  loading: PropTypes.bool,
}

ScreenDistrict.propTypes = {
  ready: false,
  loading: false,
}

export default ScreenDistrict
